import { useIsCircleAiEnabled } from "@circle-react/components/CircleAi/useCircleAiFeatureFlags";
import { useCircleV4 } from "@circle-react/hooks/useCircleV4";

import { useTrialBanner } from "@/react/components/Layout/TrialBanner/useTrialBanner";
import { useIsFeatureFlagEnabled } from "@/react/hooks/UseCommunitySetting";

import { CircleAIMarketingCampaignBanner } from "./CircleAIMarketingCampaignBanner";
import { TrialBanner } from "./TrialBanner";

export const TrialOffer = () => {
  const { isCommunityOnTrial } = useTrialBanner();
  const { isCircleV4 } = useCircleV4();
  const isGrowthCampaignEnabled = useIsFeatureFlagEnabled(
    "growth_circle_ai_marketing_campaign_enabled",
  );
  const isCircleAIEnabled = useIsCircleAiEnabled();

  if (!isCommunityOnTrial) {
    return null;
  }

  if (isCircleV4 && isGrowthCampaignEnabled && isCircleAIEnabled) {
    return <CircleAIMarketingCampaignBanner />;
  }

  return <TrialBanner />;
};
